"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTradeDateWithinBounds = void 0;
const tradingHolidays_1 = require("../../constants/tradingHolidays");
const isWeekday_1 = require("../../utils/isWeekday");
const toIsoDate_1 = require("../../utils/toIsoDate");
const index_1 = require("../addTradingDays/index");
const getEasternTime_1 = require("../../utils/getEasternTime");
function isTradeDateWithinBounds(date) {
    const isoDate = (0, toIsoDate_1.toIsoDate)(date);
    const nextTradeDate = (0, index_1.addTradingDays)((0, getEasternTime_1.getEasternTime)('ISO_DATE'), 1);
    return (!(isoDate === null) &&
        isoDate >= '2020-01-01' &&
        isoDate <= nextTradeDate &&
        (0, isWeekday_1.isWeekday)(isoDate) &&
        !tradingHolidays_1.tradingHolidays.includes(isoDate));
}
exports.isTradeDateWithinBounds = isTradeDateWithinBounds;
//# sourceMappingURL=index.js.map